<template>
<v-fade-transition :hide-on-leave="true">
  <HLCardLayout v-if="visible" :scale="(isXsDevice)?0.7:(isXlDevice)?0.4:0.7" :disablePadding="isXsDevice">
    <template #title>
      {{$t('app_event_finish_title')}}
    </template>
    <template #action>
      <v-btn
        class="mb-sm-2 ml-n3"
        elevation="0"
        fab
        dark
        small
        @click.stop="onClose"
        color="rgba(0,0,0,0.8)"
      >
        <v-icon dark opacity="0.5">
          mdi-close
        </v-icon>
      </v-btn>
    </template>
    <template #content>
      <div v-if="shouldShowFinishText">
        <div v-if="hasFinishText" class="text-sm-h6 pa-1 pa-sm-0" :style="{'color':theme.textColor}" v-html="finishText"></div>
        <EspError v-else icon="mdi-clock-alert">
        {{$t('app_event_finish_default')}}
        </EspError>
      </div>
    </template>
  </HLCardLayout>
</v-fade-transition>
</template>

<script>
import HLCardLayout from '@/components/dashboard/HLCardLayout.vue'
import EspError from '@/components/animation/EspError.vue'
import {layoutMixin} from '@/utils/layout-mixin'
import {settingsMixin} from '@/utils/settings-mixin'
import {eventMixin} from '@/utils/event-mixin'
import {spotMixin} from '@/utils/spot-mixin'
import {Howl} from 'howler';//Howler
export default {
  mixins: [layoutMixin,settingsMixin,eventMixin,spotMixin],
  components:{
    HLCardLayout,
    EspError
  },
  data(){
    return {
      visible:false,
      sound:null
    }
  },

  watch:{
    'selectedEvent.active': {
      handler(active) {
        if(active && !this.completeEvent){
          
          //Redirect to game if its active
          this.onClose();
        }
      },
      immediate: true
    }
  },

  computed: {
    shouldShowFinishText(){
      return this.eventIsInactive || this.completeEvent;
    }
  },
  methods: {
    onClose(){
      this.stopSound();
      if(this.selectedEventId){
        this.goToEvent(this.selectedEventId)
      }else{
        this.goBack();
      }
    },
    playSound(){
        let soundFile = 'final.mp3'
        this.sound = new Howl({
            src: [`/sounds/${soundFile}`],
            volume: 0.5, // TODO - make it customizable
        });
        this.sound.play();
    },
    stopSound(){
      if(this.sound){
        this.sound.stop();
      }
    }
  },
  mounted() {
    if(this.shouldShowFinishText){
      if (process.env.VUE_APP_PLAY_FINISHED_SOUND) {
        this.playSound();
      }
      setTimeout(()=>{
        this.visible=true;
      },3500);
    }
  },
}
</script>

<style scoped>

.container{
  max-width: 600px;
}
</style>